import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from '@/lib/api';
import { CountryType } from '@/types/address';
const useCountries = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["countries"],
      queryFn: fetchCountries,
      staleTime: 3600000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
export default useCountries;